<script>
import { throttle } from 'lodash'
export default {
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      originData: Object.assign({}, this.defaultValue),
    }
  },
  methods: {
    onReset: throttle(function() {
      this.$emit('update:defaultValue', Object.assign({}, this.originData))
      this.$refs['search-form'].resetFields()
      this.$emit('reset')
    }, 2000),
  },
}
</script>

<template>
  <el-form ref="search-form" :model="defaultValue" :class="$style.wrapper" class="el-form-item--normal-margin" inline>
    <div :class="$style.fields">
      <slot :fields="defaultValue"></slot>
    </div>

    <el-button type="primary" plain @click="onReset">重置</el-button>
  </el-form>
</template>

<style lang="scss" module>
@import '@design';
.wrapper {
  :global {
    .el-form-item {
      margin-bottom: 10px;
    }
    .el-select {
      width: initial;
    }
  }

  @include layer-elevation(4);

  display: flex;
  justify-content: space-between;
  padding: 10px;
  margin-bottom: 10px;
  background: white;
}
.fields {
  :global {
    .el-form-item {
      margin-bottom: 0;
      & + & {
        padding-left: 10px;
        border-left: 1px solid $color-border-base;
      }
    }
    .el-input__inner {
      background-color: transparent;
    }
  }

  display: flex;
}
</style>
